module.exports = __webpack_public_path__ + "img/image22.93bc6878.png";